import { isValidElement } from 'react';

import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

import { cn } from '@utils/cn';

import { chartWrapper } from '../Chart.styles';
import type { BarChartsProps } from '../Chart.types';

import { CustomTooltip } from './CustomTooltip';

export const BarsChart = ({
  showLegend,
  label,
  size,
  tooltip,
  className,
  ...chartProps
}: BarChartsProps) => {
  const categoryKey = chartProps?.xAxis?.dataKey;
  const valueKey = chartProps?.dataset?.[0]?.dataKey;
  const layout = chartProps?.barChart?.layout ?? 'horizontal';
  const isVertical = layout === 'vertical';

  const xAxisDataKey = isVertical ? valueKey : categoryKey;
  const xAxisType = isVertical ? 'number' : 'category';

  const yAxisDataKey = isVertical ? categoryKey : undefined;
  const yAxisType = isVertical ? 'category' : 'number';

  return (
    <div className={cn(chartWrapper(), className)}>
      <ResponsiveContainer debounce={20} width="100%" height={size?.height || 300}>
        <BarChart {...chartProps?.barChart}>
          <CartesianGrid vertical={false} />
          <XAxis
            {...chartProps.xAxis}
            dataKey={xAxisDataKey}
            type={xAxisType}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            {...chartProps.yAxis}
            dataKey={yAxisDataKey}
            type={yAxisType}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            content={
              isValidElement(tooltip) ? (
                tooltip
              ) : (
                <CustomTooltip
                  customTooltipLabel={{
                    title: label?.top ? label.top : '',
                    unit: label?.center ? label.center : ''
                  }}
                />
              )
            }
            cursor={false}
          />
          {showLegend === true && <Legend />}
          {(chartProps?.dataset || []).map((set, index) => (
            <Bar key={index} radius={8} {...set} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
